import React, { Component } from 'react';
import {
  Button,
  Grid,
  Modal,
  Row,
  Table,
  Form,
  FormGroup,
  FormControl,
  Col,
  ControlLabel,
} from 'react-bootstrap';
import DatePicker from 'react-date-picker';
import LoaderButton from '../components/LoaderButton';
import { invokeApig } from '../libs/awsLib';
import yyyymmdd from '../libs/date_convert';

export default class ViewForecast extends Component {
  constructor(props) {
    super(props);
    this.file = null;
    this.state = {
      isLoading: true,
      forecastData: {},
      currentDate: new Date(),
      searchDate: yyyymmdd(new Date()),
      showPicker: true,
      showModal: false,
    };
    this.closeModal = this.closeModal.bind(this);
    this.showModal = this.showModal.bind(this);
    this.handleDateChangeV2 = this.handleDateChangeV2.bind(this);
    this.updateForecastData = this.updateForecastData.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.showDatePicker = this.showDatePicker.bind(this);
    this.getForecastData = this.getForecastData.bind(this);
  }

  showDatePicker() {
    this.setState({
      showPicker: !this.state.showPicker,
    });
  }

  showModal(item, quantity) {
    console.log(item);
    console.log(quantity);
    this.setState({
      showModal: true,
      Modal_item: item,
      Modal_quant: quantity,
    });
  }

  closeModal() {
    this.setState({ showModal: false });
  }

  handleChange(e) {
    console.log(e);
    this.setState({ Modal_quant: e.target.value });
  }

  async getForecastData() {
    try {
      const test = await invokeApig({
        path: `/forecast/view/${this.state.searchDate}`,
        method: 'GET',
      });

      this.setState({
        isLoading: false,
        forecastData: JSON.parse(test.body),
        showPicker: false,
        showModal: false,
      });
    } catch (e) {
      console.error(e);
    }
  }

  async updateForecastData() {
    try {
      await invokeApig({
        path: '/forecast/update',
        method: 'PUT',
        body: {
          item: this.state.Modal_item,
          quantity: this.state.Modal_quant,
          date: this.state.searchDate,
        },
      });
      this.getForecastData();
    } catch (e) {
      console.error(e);
    }
  }

  transformFromIDtoPretty(item) {
    const pattern = '_';
    const re = new RegExp(pattern, 'g');
    const str = item.replace(re, ' ').toLowerCase();
    return str.replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  }

  handleDateChangeV2(value) {
    this.setState({
      searchDate: yyyymmdd(value),
      currentDate: value,
    });
  }

  render() {
    let headers = [];
    let rows = [];
    headers = [
      <tr key="header-table">
        <th key="Item">Item</th>
        <th key="Quantity">Quantity</th>
      </tr>,
    ];

    if (this.state.forecastData.length > 0) {
      rows = this.state.forecastData.map((header) => (
        <tr key={header.Item + header.Date}>
          <td onClick={() => this.showModal(header.Item, header.Quantity)}>
            {header.Item}
          </td>
          <td>{header.Quantity}</td>
        </tr>
      ));
    } else {
      rows = (
        <tr key="NO-Data">
          <td key="NO-Data"> No Data for this date</td>
        </tr>
      );
    }
    return (
      <div>
        {!this.state.showPicker && (
          <LoaderButton
            block
            bsStyle="primary"
            bsSize="large"
            onClick={this.showDatePicker}
            type="submit"
            isLoading={this.state.isLoading}
            text="Choose Another Date"
            loadingText="Loading Locations…"
          />
        )}
        {this.state.showPicker && (
          <Grid style={{ minHeight: '100vh' }}>
            <Row className="text-center" style={{ marginBottom: '15px' }}>
              <DatePicker
                onChange={this.handleDateChangeV2}
                value={this.state.currentDate}
              />
            </Row>
            <Row className="text-center">
              <Button
                bsStyle="primary"
                bsSize="large"
                onClick={this.getForecastData}
              >
                {' '}
                Search{' '}
              </Button>
            </Row>
          </Grid>
        )}
        {this.state.showModal && (
          <Modal show={this.state.showModal} onHide={this.closeModal}>
            <Modal.Header closeButton>
              <Modal.Title>{this.state.Modal_item}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form horizontal>
                <FormGroup controlId="formHorizontalEmail">
                  <Col componentClass={ControlLabel} sm={2}>
                    {this.transformFromIDtoPretty(this.state.Modal_item)}
                  </Col>
                  <Col sm={10}>
                    <FormControl
                      type="number"
                      value={this.state.Modal_quant}
                      onChange={this.handleChange}
                    />
                  </Col>
                </FormGroup>
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <Button onClick={this.closeModal}>Close</Button>
              <Button onClick={this.updateForecastData} bsStyle="primary">
                Save changes
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {!this.state.isLoading && (
          <Table bordered responsive>
            <thead>{headers}</thead>
            <tbody>{rows}</tbody>
          </Table>
        )}
      </div>
    );
  }
}
